import React from 'react';
import PropTypes from 'prop-types';

// Eri tyylivariantit (taustavärit, tekstit, varjot väreittäin)
const variantStyles = {
  default: {
    className:
      "dark:bg-primary dark:hover:border-2 dark:hover:opacity-90 dark:border-white dark:text-darkest bg-darkest hover:border-2 hover:border-opacity-90 hover:opacity-90 border-linkcolhover text-primary font-customFont1 font-normal",
    style: { boxShadow: "0 0 12px 2px rgba(255, 255, 255, 0.4)" }
  },

  addtocart: {
    className:
      "min-w-[130px] text-xs sm:text-sm md:text-base h-10 sm:h-11 lg:h-12 px-4 " +
      "dark:hover:border-2 dark:hover:opacity-90 dark:border-white dark:text-white " +
      "bg-lime-500 hover:border-2 hover:border-opacity-90 hover:opacity-90 " +
      "border-linkcolhover text-white font-normal font-customFont1",
    style: { boxShadow: "0 0 12px 2px rgba(132, 204, 22, 0.6)" }
  },
  
  removefromcart: {
    className:
      "min-w-[130px] text-xs sm:text-sm md:text-base h-10 sm:h-11 lg:h-12 px-4 " +
      "dark:hover:border-2 dark:hover:opacity-90 dark:border-white dark:text-white " +
      "bg-red-700 hover:border-2 hover:border-opacity-90 hover:opacity-90 " +
      "border-linkcolhover text-white font-normal font-customFont1",
    style: { boxShadow: "0 0 12px 2px rgba(239, 68, 68, 0.6)" }
  },
  
  makeabooking: {
    className:
      " text-xs sm:text-sm md:text-base h-10 sm:h-11 lg:h-12 px-4 " +
      "dark:hover:border-2 dark:hover:opacity-90 dark:border-white dark:text-white " +
      "bg-blue-800 hover:border-2 hover:border-opacity-90 hover:opacity-90 " +
      "border-linkcolhover text-white font-normal font-customFont1",
    style: { boxShadow: "0 0 12px 2px rgba(59, 130, 246, 0.6)" }
  },

  scrolltotop: {
    className:
      "text-xs sm:text-sm md:text-base h-10 sm:h-11 lg:h-12 px-4 " +
      "dark:hover:border-2 dark:hover:opacity-90 dark:border-white dark:text-darkest " +
      "bg-darkest dark:bg-primary hover:border-2 hover:border-opacity-90 hover:opacity-90 " +
      "border-linkcolhover text-primary font-normal font-customFont1 w-12",
    style: {}
  },

  proceedtocheckout: {
    className:
      "w-full text-sm py-2 px-4 font-extrabold font-customFont1 tracking-wide uppercase " +
      "bg-gradient-to-r from-linkcol to-accent hover:from-accent hover:to-primary " +
      "dark:text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-500 ease-in-out " +
      "border-2 border-darkest dark:border-blue-500",
    style: { boxShadow: "0 0 25px rgba(255, 255, 255, 0.25)" }
  },

  productcardaddtocart: {
    className:
      "w-full xxxsm:w-24 xsm:w-28 sm:w-32 md:w-36 lg:w-40 xl:w-48 h-8 " +
      "dark:hover:border-1 dark:hover:opacity-90 dark:border-white dark:text-darkest " +
      "bg-lime-500 hover:border-2 hover:border-opacity-90 hover:opacity-90 " +
      "border-linkcolhover text-white font-normal font-customFont1 text-[12px]",
    style: { boxShadow: "0 0 12px 2px rgba(132, 204, 22, 0.6)" }
  },

  closeform: {
    className:
      "text-sm sm:text-base md:text-lg px-6 py-2 mt-2 " +
      "dark:bg-gradient-to-r from-pink-500 via-purple-500 to-yellow-400 " +
      "text-white bg-darkest font-normal font-customFont1 tracking-wide rounded-full shadow-md " +
      "transition-all duration-300 ease-in-out transform hover:scale-105 " +
      "hover:shadow-2xl hover:brightness-110 border border-white",
    style: {
      boxShadow: "0 0 15px rgba(255, 255, 255, 0.6)"
    }
  },

  modalbutton: {
    className:
      "w-full sm:w-48 h-14 text-lg text-primary font-customFont1 dark:text-darkest font-normal px-6 py-3 " +
      "dark:bg-primary bg-darkest " +
      "rounded-full shadow-md hover:shadow-lg transition-all duration-300 ease-in-out hover:scale-105",
    style: {
      boxShadow: "0 0 12px rgba(48, 242, 207, 0.5)"
    }
  },
  
  productcardremovefromcart: {
    className:
      "w-full xxxsm:w-24 xsm:w-28 sm:w-32 md:w-36 lg:w-40 xl:w-48 h-8 " +
      "dark:hover:border-1 dark:hover:opacity-90 dark:border-white dark:text-darkest " +
      "bg-red-600 hover:border-2 hover:border-opacity-90 hover:opacity-90 " +
      "border-linkcolhover text-white font-normal font-customFont1 text-[12px]",
    style: { boxShadow: "0 0 12px 2px rgba(239, 68, 68, 0.6)" }
  },

  productcarddetails: {
    className:
      "w-full xxxsm:w-24 xsm:w-28 sm:w-32 md:w-36 lg:w-40 xl:w-48 h-8 " +
      "dark:hover:border-1 dark:hover:opacity-90 dark:border-white dark:text-white " +
      "bg-blue-700 hover:border-2 hover:border-opacity-90 hover:opacity-90 " +
      "border-linkcolhover text-white font-normal font-customFont1 text-[12px]",
    style: { boxShadow: "0 0 8px 1px rgba(59, 130, 246, 0.5)" }
  },
  
  backbutton: {
    className:
      "xxxsm:h-10 xxxsm:w-28 xxxsm:text-sm " +  // xxxsm: 320px - 374px, tekstikoko sm
      "xxsm:h-10 xxsm:w-28 xxsm:text-base " +  // xxsm: 375px - 389px, tekstikoko base
      "s24:h-12 s24:w-32 s24:text-lg " +  // s24: 390px - 429px, tekstikoko lg
      "xsm:h-12 xsm:w-36 xsm:text-lg " +  // xsm: 430px - 639px, tekstikoko xl
      "sm:h-18 sm:w-40 sm:text-lg " +  // sm: 640px - 767px, tekstikoko 2xl
      "md:h-18 md:w-44 md:text-lg" +  // md: 768px - 880px, tekstikoko 3xl
      "mdd:h-18 mdd:w-48 mdd:text-lg " +  // mdd: 881px - 1023px, tekstikoko 4xl
      "lg:h-18 lg:w-48 lg:text-lg" +  // lg: 1024px - 1279px, tekstikoko 5xl
      "xl:h-18 xl:w-48 xl:text-2xl" +  // xl: 1280px - 1535px, tekstikoko 6xl
      "2xl:h-18 2xl:w-48 2xl:text-lg" +  // 2xl: 1536px ja suuremmat, tekstikoko 7xl
  
      "font-extrabold font-customFont1 tracking-wide uppercase" +
      "bg-gradient-to-r from-linkcol to-accent hover:from-accent hover:to-primary " +
      "dark:text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-500 ease-in-out " +
      "border-2 border-darkest dark:border-blue-500",
    style: {  boxShadow: "0 0 25px rgba(255, 255, 255, 0.25)" }
  },
  
  hero: {
    className:
      "h-16 sm:h-20 md:h-24 text-lg font-extrabold font-customFont1 tracking-wide uppercase " +
      "bg-gradient-to-r from-linkcol to-accent hover:from-accent hover:to-primary " +
      "dark:text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-500 ease-in-out " +
      "border-2 border-darkest dark:border-blue-500",
    style: { boxShadow: "0 0 25px rgba(255, 255, 255, 0.25)" }
  },

  servicesreadmore: {
    className:
      "dark:bg-primary dark:hover:border-2 dark:hover:opacity-90 dark:border-white dark:text-darkest bg-darkest hover:border-2 hover:border-opacity-90 hover:opacity-90 border-linkcolhover text-primary font-customFont1 font-bold",
    style: { boxShadow: "0 0 12px 2px rgba(255, 255, 255, 0.4)" }
  },

  seemore: {
    className:
      "h-12 sm:h-14 md:h-16 text-base sm:text-lg md:text-xl font-bold font-customFont1 tracking-wide uppercase " +
      "bg-gradient-to-r from-linkcol to-accent hover:from-accent hover:to-linkcol " +
      "dark:text-white text-darkest rounded-full shadow-md hover:shadow-xl transition-all duration-500 ease-in-out " +
      "border-2 border-darkest dark:border-blue-500 w-44 sm:w-52 md:w-60",
    style: { boxShadow: "0 0 20px rgba(255, 255, 255, 0.2)" }
  },

  artistcardbutton: {
    className:
      "h-10 sm:h-11 md:h-12 text-sm font-normal font-customFont1 tracking-wide " +
      "bg-gradient-to-r from-linkcol to-accent hover:from-accent hover:to-linkcol " +
      "dark:text-white text-darkest rounded-full shadow-md hover:shadow-xl transition-all duration-300 ease-in-out " +
      "border border-darkest dark:border-blue-500 w-36 sm:w-40 md:w-44",
    style: { boxShadow: "0 0 15px rgba(255, 255, 255, 0.2)" }
  },

  askwithform: {
    className:
      "h-10 sm:h-11 md:h-12 text-sm sm:text-base md:text-lg font-semibold font-customFont1 tracking-wide " +
      "bg-gradient-to-r from-linkcol to-accent hover:from-accent hover:to-linkcol " +
      "dark:text-white text-darkest rounded-full shadow-md hover:shadow-xl transition-all duration-300 ease-in-out " +
      "border border-darkest dark:border-blue-500 w-36 sm:w-40 md:w-44",
    style: { boxShadow: "0 0 15px rgba(255, 255, 255, 0.2)" }
  },
};

const ResponsiveButton = ({
  onClick,
  children,
  icon: Icon,
  className = '',
  style = {},
  variant = 'default',
  disabled = false,
  ...props
}) => {
  const variantData = variantStyles[variant] || variantStyles.default;
  const mergedStyle = { ...variantData.style, ...style };
  const variantClass = variantData.className;

  return (
<button
  onClick={onClick}
  disabled={disabled}
  className={`h-12 flex justify-center items-center gap-2
    ${variantClass}
    font-customFont1 font-bold text-lg rounded-full
    truncate transition duration-300 ease-in
    ${className}
    ${
      disabled
        ? "opacity-50 cursor-not-allowed pointer-events-none"
        : `cursor-pointer ${
            variant !== "proceedtocheckout"
              ? "transform hover:scale-x-110 hover:scale-y-105"
              : ""
          }`
    }
  `}
  style={mergedStyle}
  {...props}
>
  {Icon && <Icon className="text-sm sm:text-base" />}
  <span className="font-customFont1 truncate">{children}</span>

</button>

  );
};

ResponsiveButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  icon: PropTypes.elementType,
  className: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.string,
  disabled: PropTypes.bool
};

export default ResponsiveButton;
